import { DistanceSlider } from "@clipboard-health/ui-components";
import { type AgentPreferences } from "@src/appV2/Agents/api/useWorkerPreferences/types";
import { DISTANCE_PREFERENCE_MAX_VALUE_IN_MILES } from "@src/constants";
import { useController, type UseControllerProps } from "react-hook-form";

type DistanceField = Pick<AgentPreferences, "distance">;

type Props<T extends DistanceField> = UseControllerProps<T> & {
  disabled: boolean;
};

export function ShiftBlockDistanceField<T extends DistanceField>(props: Props<T>) {
  const { name, control, disabled } = props;
  const { field } = useController<T>({
    name,
    control,
  });

  return (
    <DistanceSlider
      aria-label="Distance"
      disabled={disabled}
      value={field.value}
      options={[10, 50, 100, 150]}
      step={10}
      min={10}
      max={DISTANCE_PREFERENCE_MAX_VALUE_IN_MILES}
      data-testid="shift-block-filter-distance-slider"
      onChange={(_event, newValue) => {
        field.onChange(newValue);
      }}
    />
  );
}
